import * as allTypes from '../mutation-type';
import * as types from './pointDeVente-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import pdvInitial from '@/configuration/pdvConfig';
import { RAYON_DEFAULT } from '@/configuration/configurationCarte';
import { browseClients } from '@/api/clients/index';
import * as config from '@/configuration/clientConf';
import formatageConcurrents from '@/services/concurrent/concurrent';
import { getPiecesJointeLogoConcurrents } from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import gestionErreur from '@/services/general/gestionErreur';

const cloneData = pdvInitial;

function initialState() {
  return {
    pointDeVente: cloneDeep(cloneData),
    rayon: RAYON_DEFAULT,
    concurrents: [],
    nbreConcurrents: 0,
    isModifPdv: false,
    concurrentSelectionnes: [],
    lastRayon: null,
    adressePointCentral: null,
    afficherMarkerPdv: true,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  // utilisé pour la création d'un client pdv
  [types.SET_PROPRIETY_POINT_DE_VENTE](state, { key, value }) {
    state.pointDeVente[key] = value;
  },
  [types.VIDER_PDV](state) {
    state.pointDeVente = cloneDeep(cloneData);
  },
  // utilisé pour les concurents
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_LAST_RAYON](state, lastRayon) {
    state.lastRayon = lastRayon;
  },
  [types.SET_CONCURRENTS](state, concurrents) {
    state.concurrents = concurrents;
  },
  [types.SET_CONCURRENT_SELECTIONNES](state, concurrentSelectionnes) {
    state.concurrentSelectionnes = concurrentSelectionnes;
  },
  [types.SET_NBRE_CONCURRENTS](state, nbreConcurrents) {
    state.nbreConcurrents = nbreConcurrents;
  },
  [types.SET_ADRESSE_POINT_CENTRAL](state, value) {
    state.adressePointCentral = value;
  },
  [types.SET_AFFICHER_MARKER_PDV](state, val) {
    state.afficherMarkerPdv = val;
  },
  // utiliser au niveau du panier
  [types.SET_IS_MODIF_PDV](state, isModifPdv) {
    state.isModifPdv = isModifPdv;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  recupererConcurrents : async({ rootGetters, getters, commit }) => {
    const pointDeVente = rootGetters['recommandations/pointDeVente'];
    if (!pointDeVente) return;
    const societeId = rootGetters['societe/societeActiveId'];
    const query = {
      societeId,
      archive: false,
      rayon: getters.rayon,
      type: config.TYPE_CLIENT,
      typologie: config.POINT_VENTE,
      sousType: config.SOUS_TYPE_CONCURRENT,
      latitude: pointDeVente.adressePostale.latitude,
      longitude: pointDeVente.adressePostale.longitude,
    };
    try {
      // les concurrents ont leur propre règle de logo, on court-circuite celle de browseClients
      const pdvs = (await browseClients(config.WITHOUT_LOGO, query)).data;
      await getPiecesJointeLogoConcurrents(pdvs);
      const marques = rootGetters['parametrage/parametre'](PARAMETRES_KEYS.marque);
      const secteursActivites = rootGetters['parametrage/parametre'](PARAMETRES_KEYS.secteurActivite);
      const data = formatageConcurrents(pdvs, secteursActivites, pointDeVente.secteurActiviteId, marques);
      let nbreReelConcurrent = 0;
      data.forEach(el => {
        el.children.forEach(child => {
          if (child.children.length) nbreReelConcurrent += child.children.length;
          else nbreReelConcurrent += 1;
        })
      });
      commit(types.SET_CONCURRENTS, data);
      commit(types.SET_NBRE_CONCURRENTS, nbreReelConcurrent);
    } catch (error) {
      gestionErreur('Erreur lors de la récupération des concurrents', error);
    }
  },
};

const getters = {
  pointDeVente: state => {
    return state.pointDeVente;
  },
  rayon: (state) => {
    return state.rayon;
  },
  lastRayon: (state) => {
    return state.lastRayon;
  },
  adressePointCentral: (state) => {
    return state.adressePointCentral;
  },
  concurrents: (state) => {
    return state.concurrents;
  },
  concurrentSelectionnes: (state) => {
    return state.concurrentSelectionnes;
  },
  nbreConcurrents: (state) => {
    return state.nbreConcurrents;
  },
  pdvConcurrentSelected: (state) => {
    const marques = state.concurrents
      .map(c => c.children).flat();
    const pdvs = marques
      .map(c => c.children).flat();
    return [
      ...pdvs,
      ...marques.filter(e => e.isPdv)
    ].filter(c => c.selected)
  },
  isModifPdv: (state) => {
    return state.isModifPdv;
  },
  afficherMarkerPdv: (state) => {
    return state.afficherMarkerPdv;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
